import { memo } from "react";
import { useTranslate } from "helpers";
import { FleetTireAddRow } from "services/api/fleet/tires/types";
import { TableSearch } from "ui/components/Table/TableSearch";
import { NoResults } from "ui/components/NoResults";
import { TIRE_SET_TIRES_COLUMNS } from "./consts";

interface TireSetTiresCardProps {
    tires: FleetTireAddRow[];
}

const TireSetTiresCard: React.FC<TireSetTiresCardProps> = ({ tires }) => {
    const { t } = useTranslate();

    return (
        <div className="m-[-1px]">
            {!tires || tires.length === 0 ? (
                <NoResults message="Nema guma u ovom setu." />
            ) : (
                <TableSearch
                    columns={TIRE_SET_TIRES_COLUMNS(t)}
                    data={tires}
                    selectableRows={false}
                    disablePagination={true}
                    isLoading={false}
                />
            )}
        </div>
    );
};

export default memo(TireSetTiresCard);
